import { Typography, styled } from '@mui/material';

export const Subtitle = styled(Typography)({
  fontWeight: 700,
  fontSize: '24px',
  lineHeight: '34px',
});
